"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ConfirmSceneTranslation = {
    fi: {
        ConfirmScene: {
            title: 'Tunnuksesi on nyt aktivoitu',
            toLogin: 'Takaisin',
            subTitle: 'Tunnuksesi on aktivoitu. Voit nyt jatkaa ohjelman käyttöä',
        },
    },
    en: {
        ConfirmScene: {
            title: 'Your account is now activated.',
            toLogin: 'Back',
            subTitle: 'Your account is now activated. You can now continue using application.',
        },
    },
};
exports.default = ConfirmSceneTranslation;
//# sourceMappingURL=ConfirmScene.translation.js.map